import { Avatar, Box, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

const AVATAR_SIZE = 32;

type UserAvatarProps = {
  userInitials: string;
  avatarUrl?: string | null;
};

export const UserAvatar = ({ avatarUrl, userInitials }: UserAvatarProps) => {
  if (avatarUrl) {
    return (
      <Box
        sx={{
          border: t => `2px solid ${t.palette.divider}`,
          borderRadius: borderRadius('xl'),
        }}
      >
        <Avatar
          sx={{
            width: AVATAR_SIZE,
            height: AVATAR_SIZE,
          }}
          src={avatarUrl}
        />
      </Box>
    );
  }

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      width={AVATAR_SIZE}
      height={AVATAR_SIZE}
      sx={{
        borderRadius: borderRadius('xl'),
        border: t => `1px solid ${t.palette.divider}`,
      }}
    >
      <Typography color="text.primary" variant="body2">
        {userInitials}
      </Typography>
    </Stack>
  );
};
